import { resolveCloudScreenshotUrl } from "../../../../lib/utils";

const CUSTOM_SCREENSHOTS_BASE = "instructions/screenshots";
const cloudScreenshot = (relativePath) => resolveCloudScreenshotUrl(`${CUSTOM_SCREENSHOTS_BASE}/${relativePath}`);

export const MISSION_TWO_SCREENSHOT_LAYOUT_BY_PAGE = {
 m201: {
  src: cloudScreenshot(`screenshots_m2/instructions 2.01.svg`),
  title: "NEXT MISSION",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 42,
  maxWidthPercent: 48,
  titleWidthPercent: 28,
  titleLeftPercent: 50,
  titleTopVw: -0.25,
 },
 m202: {
  src: cloudScreenshot(`screenshots_m2/instructions 2.02.svg`),
  title: "Trucks Cutting In",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 45,
  maxWidthPercent: 48,
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m203: {
  src: cloudScreenshot(`screenshots_m2/instructions 2.03.svg`),
  title: "Trusting/ Ignoring Trucks",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 45,
  maxWidthPercent: 48,
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m204: {
  src: cloudScreenshot(`screenshots_m2/instructions 2.04.svg`),
  title: "Regaining Control",
  leftPercent: 60,
  topPercent: 10,
  widthPercent: 64,
  maxWidthPercent: 64,
  details: [
   { left: 41.9, top: 54.4, key: "KeyZ", fontSizeVw: 0.64 },
   { left: 43.6, top: 54.4, key: "KeyS", fontSizeVw: 0.74 },
   { left: 45.55, top: 54.4, key: "KeyD", fontSizeVw: 0.74 },
   { left: 48.2, top: 54.4, key: "KeyF", fontSizeVw: 0.74 },
   { left: 53, top: 54.4, key: "KeyK", fontSizeVw: 0.74 },
   { left: 55.3, top: 54.4, key: "KeyL", fontSizeVw: 0.74 },
   { left: 57.6, top: 54.4, key: "Semicolon", fontSizeVw: 0.74 },
   { left: 59.3, top: 54.4, key: "Slash", fontSizeVw: 0.64 },
  ],
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m205: {
  src: cloudScreenshot(`screenshots_shared/instructions 2.05 1.07 0.13.svg`),
  title: "Check-Ins",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 45,
  maxWidthPercent: 48,
  details: [
   { left: 48.4, top: 54.4, key: "KeyS", fontSizeVw: 0.74, color: "#000000", textStroke: "0px" },
   { left: 50.55, top: 54.4, key: "KeyD", fontSizeVw: 0.74, color: "#000000", textStroke: "0px" },
   { left: 52.65, top: 54.4, key: "KeyF", fontSizeVw: 0.74, color: "#000000", textStroke: "0px" },
   { left: 54.7, top: 54.4, key: "KeyK", fontSizeVw: 0.74, color: "#000000", textStroke: "0px" },
   { left: 56.8, top: 54.4, key: "KeyL", fontSizeVw: 0.74, color: "#000000", textStroke: "0px" },
   { left: 58.9, top: 54.4, key: "Semicolon", fontSizeVw: 0.74, color: "#000000", textStroke: "0px" },
  ],
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m206: {
  src: cloudScreenshot(`screenshots_m2/instructions 2.06.svg`),
  title: "Ready to Play",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 45,
  maxWidthPercent: 45,
  titleWidthPercent: 28,
  titleLeftPercent: 50,
  titleTopVw: -0.25,
 },
};
